<template>
  <generic-modal
    size
    :title="$t('clothing meassurement')"
    icon="tshirt"
    image="/images/icons/clothing_meassurement-1.png"
    v-bind:scrolling="true"
    v-on:destroy="destroy"
    v-bind:on_finished="this.finished"
  >
    <div class="description">test</div>
  </generic-modal>
</template>

<script>
// import { local_api } from "../utils";
import GenericModal from "@/components/GenericModal";
// import GenericContainer from "./GenericContainer";
import { v4 } from "uuid";

export default {
  components: {
    "generic-modal": GenericModal
    // "generic-container": GenericContainer
  },
  computed: {},
  data() {
    return {};
  },
  methods: {
    add_campaign() {
      let campaign = { id: v4(), name: this.$t("new campaign"), items: "" };
      this.campaigns.push(campaign);
      this.shown_campaigns.push(campaign);
    },
    remove_campaign(campaign, index) {
      this.shown_campaigns.splice(index, 1);
      let idx = this.campaigns.findIndex(n => n.id == campaign.id);
      if (idx >= 0) this.campaigns.splice(idx, 1);
    },
    finished() {
      // let vm = this;
      // eslint-disable-next-line no-unused-vars
      return new Promise(function(resolve, reject) {
        //   local_api(vm, "post", "/clothing_meassurement/do-save-configuration", {
        //     s: { campaigns: vm.campaigns }
        //   })
        //     .then(() => {
        console.log("finished");
        resolve();
        //     })
        //     .catch(err => {
        //       reject(err);
        //     });
      });
    },
    destroy() {
      this.$emit("destroy");
      this.$destroy();
    },
    filter(query) {
      if (query == "") {
        // this.shown_campaigns = clone(this.campaigns);
      } else {
        // this.shown_campaigns = this.campaigns.filter(n =>
        //   n.name.includes(query)
        // );
      }
      console.log(query);
    }
  },
  mounted() {},
  watch: {},
  updated: function() {
    // let vm = this;
    this.$nextTick(function() {});
  }
};
</script>
